import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./lib/install";
import { Display } from "./Display";
import { StoreProvider } from "./lib/till-context";
import { takeLinkFromAddress } from "./lib/display";

// A display moved over from the till's site brings its link in the address.
takeLinkFromAddress();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <StoreProvider>
      <Display />
    </StoreProvider>
  </StrictMode>,
);
// The store's palette, chosen per site at deploy (sites.json "palette").
const palette = import.meta.env.VITE_PALETTE as string | undefined;
if (palette) document.documentElement.dataset.pack = palette;


// Installable as an app (manifest + this worker); the Install button comes from lib/install.
if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => void navigator.serviceWorker.register("/sw.js"));
}
